function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  strokeWidth: 2,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  transform: "translate(23.53 56.364)",
  stroke: "#00DACC"
}, React.createElement("ellipse", {
  strokeLinecap: "square",
  cx: 15.75,
  cy: 7.458,
  rx: 7.5,
  ry: 7.458
}), React.createElement("path", {
  d: "M0 39.525C0 31.288 7.052 24.61 15.75 24.61h0c8.698 0 15.75 6.678 15.75 14.915"
})), React.createElement("path", {
  d: "M63.89 77.25v26.104c0 3.394-2.838 6.146-6.34 6.146H19.518c-3.501 0-6.339-2.752-6.339-6.146V67.5",
  stroke: "#002A36",
  strokeLinecap: "square"
}), React.createElement("path", {
  d: "M87.754 35.716l-9.269 15.389-3.203 22.667c-.607 3.101-3.473 5.242-6.632 4.952-3.16-.29-5.585-2.916-5.612-6.076V41.871c0-5.099-4.15-9.233-9.27-9.233H22.874l-9.269 15.389v15.388c0 3.4-2.766 6.156-6.18 6.156-3.412 0-6.178-2.756-6.178-6.156V41.871l9.269-24.621L43 2",
  stroke: "#002A36",
  strokeLinecap: "square"
}));

var SvgPhotoUploadPlaceholder = function SvgPhotoUploadPlaceholder(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 90,
    height: 111,
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgPhotoUploadPlaceholder, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/photo-upload-placeholder.bd288111.svg";
export { ForwardRef as ReactComponent };